export default __webpack_public_path__ + "locales/pt-BR/SmartBanner.json?hash=170ad0bf8a57a9051fb73770cdfebc28";